// call CefSharp registration method if available

// do this only if cefsharp is detected
var isCefSharp =
  (typeof window !== "undefined" && window && window.cefSharp) || (typeof window !== "undefined" && window && window.CefSharp);

if (isCefSharp) {
  console.log("CefSharp detected, calling CefSharp registration method");
  CefSharp.BindObjectAsync()
    .then((...args) => {
      console.log("CefSharp registration method called", args);
    })
    .catch((err) => {
      console.error("CefSharp registration method failed", err);
    });
} else {
  console.log("CefSharp not detected, skipping CefSharp registration method");
}

export {};
